export default __webpack_public_path__ + "static/media/gallery_07.739642e9.jpg";